// import style from './style.module.less';

import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import Error403 from './403';
import Error404 from './404';
import { Display } from '../Display/Display';
import GrtLoading from '../GrtLoading/GRTLoading';
const Error = (props) => {
    const [load, setLoad] = useState(true),
     [isAdmin, setIsadmin] = useState(false),
        getUserInfo = async () => {
            let { login } = props.store,
                adminInfo = await login.getAdminUserInfo();
            if (adminInfo === 1) {
                setIsadmin(false);
            } else {
                setIsadmin(true);
            }
            setLoad(false);
        };

    useEffect(() => {
        getUserInfo();
    }, []);

    return (
        <>
            {load ? (
                <GrtLoading></GrtLoading>
            ) : (
                <>
                    <Display show={isAdmin}>
                        <Error404></Error404>
                    </Display>
                    <Display show={!isAdmin}>
                        <Error403></Error403>
                    </Display>
                </>
            )}
        </>
    );
};
export default inject('store')(observer(Error));
